"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _density = require("@site/pattern-library-utils/density");
var _text = _interopRequireDefault(require("@ux/text"));
var _pageEyebrow = _interopRequireDefault(require("./page-eyebrow"));
var _configItemRow = _interopRequireDefault(require("./config-item-row"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _configContext = require("../../context/config-context");
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pc-c1h4sb5t"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pc-hkhpixc"
});

/**
 * ProductConfiguration Component.
 *
 * @param {Object} props React props
 * @returns {React.RectElement} ProductConfiguration Component
 * @public
 */

function ProductConfiguration({
  ...rest
}) {
  const {
    configData
  } = (0, _configContext.useConfig)();
  if (!configData) {
    return null;
  }
  const {
    pageHeadline,
    products
  } = configData.productConfiguration;
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_pageEyebrow.default, rest), pageHeadline && /*#__PURE__*/_react.default.createElement(HeadlineWrapper, null, /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    "data-cy": "page-headline",
    as: "heading",
    dangerouslySetInnerHTML: {
      __html: _dompurify.default.sanitize(pageHeadline)
    },
    size: 1
  })), products && (() => {
    const allSections = ['properties', 'offers', 'includes', 'addons', 'banners'];
    let globalIndex = 0;
    return allSections.flatMap(sectionName => {
      const sectionData = products[sectionName] || [];
      return sectionData.map((itemWrapper, rowIndex) => {
        const {
          item,
          productId
        } = itemWrapper;
        const selectorKey = Object.keys(item).find(key => key.endsWith('Selector') || key.endsWith('Banner'));
        if (!selectorKey) {
          return null;
        }
        globalIndex++;
        return /*#__PURE__*/_react.default.createElement(_configItemRow.default, {
          key: `${productId}-${sectionName}-${rowIndex}`,
          index: globalIndex,
          selector: item[selectorKey],
          product: productId
        });
      });
    }).filter(Boolean); // Remove null values
  })());
}
var _default = exports.default = ProductConfiguration;
ProductConfiguration.propTypes = {
  pageHeadline: _propTypes.default.string,
  itemRows: _propTypes.default.arrayOf(_propTypes.default.shape(_configItemRow.default.propTypes))
};